import $ from 'jquery';
import Swiper, { EffectFade, Controller } from 'swiper';
import { Breakpoint } from '../types/breakpoint';
import LazyImages from './lazy-images';
import SwiperCore from 'swiper';
export default class BubblesSlider {
    static $slider = $('.js__bubbles-slider');
    static $contentSlider = $('.js__bubbles-content-slider');
    static slider;
    static contentSlider;
    static sliderOptions = {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 22,
        loop: true,
        loopedSlides: 6,
        breakpoints: {
            [Breakpoint.md]: {
                spaceBetween: 74,
            },
        },
    };
    static contentSliderOptions = {
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        loop: true,
        loopedSlides: 6,
        autoHeight: true,
        allowTouchMove: false,
    };
    static init() {
        if (!this.$slider.length || !this.$contentSlider.length) {
            return;
        }
        SwiperCore.use([Controller, EffectFade]);
        this.contentSlider = new Swiper(this.$contentSlider.get(0), {
            ...this.contentSliderOptions,
        });
        this.slider = new Swiper(this.$slider.get(0), {
            ...this.sliderOptions,
            controller: {
                control: this.contentSlider,
            },
        });
        LazyImages.update();
    }
}
